import { useState } from "react";

import {
  objectTypes,
  actionNames,
  useTracker,
  eventTypes,
  actionPrefixes,
} from "@newsela/snitch";

/**
 * @param {string} levelId
 * @param {any} node - image node
 * @returns {{isImageExpanded: bool, toggleZoom: function}}
 */

const useZoomInOutImage = (levelId, node) => {
  const { trackAction, getEventName } = useTracker();
  const [isImageExpanded, setIsImageExpanded] = useState(
    node?.attrs?.isFullWidth,
  );

  const actionPrefix = isImageExpanded
    ? actionPrefixes.cancel
    : actionPrefixes.initiate;
  const imageDescription = isImageExpanded ? "Zoom out image" : "Zoom in image";

  const zoomImageEventProps = {
    event_name: getEventName(
      objectTypes.content,
      actionPrefix,
      actionNames.read,
    ),
    event_type: eventTypes.click,
    dimension_properties: {
      object_type: objectTypes.content,
      content_id: levelId,
      description: imageDescription,
      content_type: "Article",
    },
  };

  const toggleZoom = () => {
    try {
      trackAction({ ...zoomImageEventProps });
      setIsImageExpanded(!isImageExpanded);
    } catch (err) {
      console.error(err);
    }
  };

  return {
    isImageExpanded,
    toggleZoom,
  };
};

export default useZoomInOutImage;
